// Salvar Associação

import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

import { Action } from '@core/components/actions/action.default';
import { ConditionEvaluatorService } from '@services/condition-evaluator/condition-evaluator.service';
import { MessagesService } from '@services/messages/message.service';

@Injectable()
export class SalvarAssociacaoAction extends Action {
  constructor(
    private message :MessagesService,
    private conditionEvaluator: ConditionEvaluatorService) {
    super();
  }

  /**
  * Pre execute step to validate the form
  * @param {object} context - The component's controler
  * @returns {Observable}
  */
 preExecute(params): Observable<any> {
   return of(params);
 }

  postExecute(params): Observable<any> {
    return of(params);
  }
}

